var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-tabs",
        {
          staticClass: "nav-tabs-underline mt-3",
          attrs: { "content-class": "mt-3" },
        },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "b-tab",
            {
              key: tab.path,
              attrs: { title: tab.name, active: _vm.currentTab === tab.name },
              on: {
                click: function ($event) {
                  return _vm.selectTab(tab.path)
                },
              },
            },
            [_c("router-view")],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }